<template>
	<div>

		<field
			class="mb-4"
			:params="{
				type: 'btn-group',
				buttons:[
					{ text: 'Address',   value:'address'},
					{ text: 'Drag a Pin',value:'pin'}
				],
				disableNull:true
			}"
			:readonly="readonly"
			:invalid="$store.errorList.location_type"
			v-model="location.location_type"
			v-on:change="tabChange">
		</field>


		<template v-if="location.location_type == 'pin'">

			<div>Drag the pin to the location</div>

			<input v-if="location.lat && location.long" type="text" readonly class="form-control text-center" v-model="'Lat: '+ location.lat + '    Long: ' + location.long">

			<vue-map
				style="margin-bottom:10px;"
				key="drop-pin-map"
				:center="{
					lat: !isNaN(+location.lat) ? +location.lat : +$store.company.lat ? +$store.company.lat : 43,
					lng: !isNaN(+location.long) ? +location.long : +$store.company.long ? +$store.company.long : -79
				}"
				:zoom="zoom"
				map-size="map-sm"
				:markers="dropMarkers"
				v-on:markerDrop="setCoordsFromDroppedPin">
			</vue-map>

			<button v-if="!showDirectionsOnMap" class="btn btn-light" v-on:click="setToCurrent">
				<i class="fa fa-map-marker"></i>
				Set to Current
			</button>
		</template>


		<div v-else class="row">

			<div v-if="mapsSrc" class="col-md-6">
				<div class="d-flex flex-column">
					<iframe
						width="100%"
						height="450"
						frameborder="0" style="border:0"
						:src="mapsSrc" allowfullscreen>
					</iframe>

					<div class="d-flex align-items-baseline flex-wrap mt-2">
						<button v-if="!showDirectionsOnMap" class="btn btn-light mr-2 mb-2" v-on:click="showDirectionsOnMap = true">
							<i class="fa fa-map"></i>
							Show Driving Directions
						</button>

						<button v-if="!showDirectionsOnMap" class="btn btn-light" v-on:click="setToCurrent">
							<i class="fa fa-map-marker"></i>
							Set to Current
						</button>
					</div>

				</div>
			</div>

			<div :class="{'col-md-6': mapsSrc, 'col-md-12': !mapsSrc}">

				<address-manual-selector
					:suite="location.suite"
					:address="location.address"
					:city="location.city"
					:province="location.province"
					:country="location.country"
					:postal-code="location.postal_code"
					:readonly="readonly"
					v-on:input="manualLocationChange"
					:invalid-list="$store.errorList">
				</address-manual-selector>

			</div>

		</div>
	</div>
</template>

<script type="text/javascript">

import VueMap from "@/components/VueMap"
import Field from "@/components/Field"
import AddressManualSelector from "@/components/AddressManualSelector"

export default {
	name: "LocationSelector",
	components: {
		Field,
		VueMap,
		AddressManualSelector
	},
	props: [
		"initialValues",
		"readonly"
	],
	data() {
		return {
			location: {
				location_type: null,
				suite: null,
				address: null,
				city: null,
				province: null,
				country: null,
				postal_code: null,
				lat: null,
				long: null
			},

			zoom: 11,

			dropMarkers: [
				{
					lat: 43.5,
					lng: -79.5,
					draggable: true
				}
			],

			showDirectionsOnMap: false,
		}
	},
	watch: {

	},
	computed: {
		mapsSrc() {
			const requiredFields = ['address', 'city', 'province', 'country', 'postal_code']

			for (let i = 0; i < requiredFields.length; i++) {
				if (!(requiredFields[i] in this.location)) {
					return false
				}
			}

			const addressQuery = requiredFields.map(field => this.location[field]).join("+")

			if (this.$store.company && this.showDirectionsOnMap) {
				const officeQuery = requiredFields.map(field => this.$store.company[field]).join("+")
				return 'https://www.google.com/maps/embed/v1/directions?key='+this.$store.GoogleEmbedAPIkey+"&destination="+addressQuery+"&origin="+officeQuery
			}

			return 'https://www.google.com/maps/embed/v1/place?key='+this.$store.GoogleEmbedAPIkey+"&q="+addressQuery
		}
	},
	methods: {
		tabChange() {
			this.$nextTick(() => {
				this.locationChange()
			})
		},
		locationChange() {
			const typeFields = {
				'address': ['location_type', 'suite', 'address', 'city', 'province', 'country', 'postal_code'],
				'pin':     ['location_type', 'lat', 'long']
			}

			const clone = this.cloneObj(this.location)

			Object.keys(clone).forEach(key => {
				if (!typeFields[clone.location_type].includes(key))
					clone[key] = ""
			})

			this.$emit('change', clone)
		},
		setToCurrent() {
			this.getLocation().then(newLocation => {
				this.location.location_type = 'pin'
				this.setCoordsFromDroppedPin(newLocation, this.dropMarkers[0])
				this.zoom = 14
			})
		},

		manualLocationChange(newLocation) {
			Object.keys(newLocation).forEach(key => {
				this.location[key] = newLocation[key]
			})
			this.locationChange()
		},

		setCoordsFromDroppedPin(position, marker) {
			this.location.lat = Math.round(position.lat*100000) / 100000
			this.location.long = Math.round(position.lng*100000) / 100000
			marker.lat = position.lat
			marker.lng = position.lng
			this.locationChange()
		},
		setInitialValues() {
			if (this.initialValues && Object.keys(this.initialValues)) {

				Object.keys(this.location).forEach(key => {
					if (key in this.initialValues)
						this.location[key] = this.initialValues[key]
					else
						this.location[key] = null
				})

				if ('lat' in this.initialValues && this.initialValues.lat && 'long' in this.initialValues && this.initialValues.long) {
					this.dropMarkers[0].lat = +this.initialValues.lat
					this.dropMarkers[0].lng = +this.initialValues.long
				}
			}
		}
	},
	mounted() {
		this.setInitialValues()
	}
}	

</script>